import { Link2 } from 'lucide-react';
import { Pill } from '@/shared/components';
import type { FlatFamilyResponse } from '@/shared/api';
import { flatFamilyBadgeLabel } from './flatFamilyModel';

/** „Gesamtwohnung · 3 Zimmer“ bzw. „Zimmer von …“ im Kopf der Apartmentakte. */
export function FlatFamilyBadge({ family }: { family: FlatFamilyResponse | null | undefined }) {
  const label = flatFamilyBadgeLabel(family);
  if (!label) return null;
  return (
    <Pill variant="default" size="md" className="max-w-full">
      <Link2 size={12} aria-hidden className="shrink-0" />
      <span className="truncate" title={label}>
        {label}
      </span>
    </Pill>
  );
}
